import React from 'react';

function StatusMessage({ type = 'info', message, onClose }) {
  if (!message) return null;

  const styles = {
    success: 'bg-green-100 border-green-400 text-green-800',
    error: 'bg-red-100 border-red-400 text-red-800',
    warning: 'bg-yellow-100 border-yellow-400 text-yellow-800',
    info: 'bg-blue-100 border-blue-400 text-blue-800'
  };

  return (
    <div className={`border-l-4 p-4 mb-4 ${styles[type]} flex justify-between items-start`}>
      <p>{message}</p>
      {onClose && (
        <button
          onClick={onClose}
          className="ml-4 text-xl font-bold hover:opacity-70"
        >
          ×
        </button>
      )}
    </div>
  );
}

export default StatusMessage;
